import React from 'react';

interface ISearchIconProps {
  fill: string;
}

const SearchIcon: React.FC<ISearchIconProps> = ({ fill }) => {
  return (
    <div>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9997 12.4163L10.2716 8.68826C10.8584 7.80232 11.1996 6.74198 11.1996 5.6C11.1996 2.50684 8.6928 0 5.6002 0C2.5076 0 0.000762939 2.5074 0.000762939 5.60056C0.000762939 8.6926 2.5076 11.2006 5.6002 11.2006C6.74153 11.2006 7.80296 10.8582 8.68846 10.272L12.416 14L13.9997 12.4163ZM1.58726 5.60112C1.58726 3.38464 3.3843 1.58872 5.60022 1.58872C7.8167 1.58872 9.61374 3.38464 9.61374 5.60112C9.61374 7.8176 7.8167 9.61464 5.60022 9.61464C3.3843 9.61464 1.58726 7.8176 1.58726 5.60112Z"
          fill={fill}
        />
      </svg>
      <style jsx>{`
        div {
          position: absolute;
          left: 8px;
          top: calc(50% - 10px);
          height: 20px;
          width: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </div>
  );
};

export default SearchIcon;
